<template>
  <div>
    <v-card>
      <v-container grid-list-lg>
        <v-layout class="ma-2" align-center="align-center" justify-center row>
          <div class="text-center">
            <h1 class="display-3 font-weight-bold">Text Messages</h1>
            <h1 class="headline">Did you know Text messages are proven to be</h1>
            <div class="text-center mt-3 font-weight-medium">
              <div>
                <span class="font-weight-black">80%</span>
                <span class="font-weight-medium"> more effective than emailing and</span>
              </div>
              <div>
                <span class="font-weight-black">150%</span>
                <span class="font-weight-medium"> more effective than mailing a pamphlet.</span>
              </div>
              <div>
                <span class="font-weight-black">98%</span>
                <span class="font-weight-medium"> of customers react to text messages.</span>
              </div>
              <div class="mb-4">
                <span>With a </span>
                <span class="display-2 font-weight-black">$5</span>
                <span> credit, you can send up to </span>
                <span class="display-2 font-weight-black">250</span>
                <span> text messages.</span>
              </div>
              <div>Stay in touch with your customers using our Promotion module.</div>
              <div>
                Connect with your customers faster and update them with your latest deals and
                promotions.
              </div>
              <div class="mt-2">
                <span class="font-weight-medium"
                  >Your current Promotion wallet account balance is
                </span>
                <span class="font-weight-black">$0.00</span>
              </div>
              <div class="mt-2 display-2">
                <span>If you buy </span>
                <span class="display-2 red--text">NOW</span>
                <span>, we’ll give you </span>
                <span class="red--text">50% MORE VALUE. </span>
              </div>
            </div>
          </div>
        </v-layout>
        <v-layout class="mt-5" align-center="align-center" justify-center row wrap>
          <div class="text-center">
            <h4 class="h4-header">
              Select One
              <v-radio-group row v-model="chargeValue" hide-details>
                <v-radio v-for="value in values" :label="value.name" :value="value.value">
                </v-radio>
              </v-radio-group>
            </h4>
            <h3 class="mt-4 mb-5 h3-header font-weight-thin">
              <span>You will pay </span>
              <span class="display-1 font-weight-light">{{ chargeValue | currency }} </span>
              <span> and get </span>
              <span class="display-1 font-weight-light">{{ getValue | currency }}</span>
            </h3>
          </div>
        </v-layout>
        <v-divider> </v-divider>
        <v-card-actions class="mt-3">
          <v-layout row wrap>
            <v-spacer> </v-spacer>
            <v-btn color="info" large text @click="removeDeal">{{ $t("buttons.noThanks") }}</v-btn>
            <v-btn color="info" large @click="save" :disabled="chargeValue === 0">{{
              $t("buttons.addtoCart")
            }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showQuestion: true,
      chargeValue: 0,
      getValue: 0,
      name: "Promotion",
      values: [
        { name: "5", value: 5 },
        { name: "10", value: 10 },
        { name: "15", value: 15 },
        { name: "20", value: 20 },
        { name: "25", value: 25 },
        { name: "50", value: 50 },
        { name: "100", value: 100 }
      ]
    };
  },
  watch: {
    chargeValue(val) {
      let newValue = (val * 50) / 100;
      this.getValue = val + newValue;
    }
  },
  methods: {
    ...mapActions("location", ["order", "removeDeal"]),
    save() {
      this.order({
        order: this.name,
        price: this.chargeValue,
        detail: `Promotion purchse ${this.chargeValue} you will got ${this.getValue} in your account`
      });
    }
  }
};
</script>

<style scoped></style>
